import { c as _c } from "react/compiler-runtime";
import { ErrorResponseInterface } from '@systemeio/util';
import { SECURE_AND_PAY_ACCOUNT_API } from 'modules/profile/payment-gateways/integrations/secure-and-pay/api';
import { PaymentSecureAndPayInterface } from 'modules/profile/payment-gateways/integrations/secure-and-pay/types';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export interface UseSecureAndPayRestApiInterface {
  badRequestHandler?: (e: ErrorResponseInterface) => void;
}
export const useSecureAndPayRestApi = t0 => {
  const $ = _c(13);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    badRequestHandler
  } = t1;
  let t2;
  if ($[2] !== badRequestHandler) {
    t2 = {
      method: RequestMethodsEnum.post,
      badRequestHandler
    };
    $[2] = badRequestHandler;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    fetcher
  } = useFetch(t2);
  let t3;
  if ($[4] !== badRequestHandler) {
    t3 = {
      method: RequestMethodsEnum.delete,
      badRequestHandler
    };
    $[4] = badRequestHandler;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t3);
  let t4;
  if ($[6] !== fetcher) {
    t4 = data => fetcher(`${SECURE_AND_PAY_ACCOUNT_API}/connect`, data);
    $[6] = fetcher;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== deleteFetcher) {
    t5 = () => deleteFetcher(`${SECURE_AND_PAY_ACCOUNT_API}/disconnect`);
    $[8] = deleteFetcher;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = {
      connect: t4,
      disconnect: t5
    };
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};